module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-progress', {
    attrs: {
      "value": 75,
      "size": "is-medium",
      "show-value": ""
    }
  }, [_vm._v("\n            Custom display with "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("HTML")])]), _vm._v(" "), _c('b-progress', {
    attrs: {
      "value": 75,
      "size": "is-medium",
      "show-value": ""
    }
  }, [_vm._v("\n            75 / 100\n        ")]), _vm._v(" "), _c('b-progress', {
    attrs: {
      "value": 75,
      "size": "is-medium",
      "show-value": ""
    }
  }, [_vm._v("\n            3 out of 4\n        ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-437f8fe7"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/progress/examples/ExSlot.vue
// module id = 1153
// module chunks = 25 199